import React from 'react';
import produce from 'immer';

import { IProps, IState } from './types';

import Input from '../../../../../../shared/design-system/components/input';
import Button from '../../../../../../shared/design-system/components/atoms/button/button-container';

import ButtonContainer from '../../../button-container';

import { validate } from './validator';

class ResetPasswordFormComponent extends React.Component<IProps, IState> {
  private turnstileRef = React.createRef<HTMLDivElement>();

  private turnstileWidgetId: string | undefined;

  constructor(props) {
    super(props);

    this.state = {
      values: {
        email: '',
      },
      errors: {
        email: '',
      },
      dirty: {
        email: false,
      },
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onInputBlur = this.onInputBlur.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
  }

  componentDidMount() {
    this.renderTurnstile();
  }

  componentWillUnmount() {
    if (this.turnstileWidgetId !== undefined) {
      (window as any).turnstile?.remove(this.turnstileWidgetId);
      this.turnstileWidgetId = undefined;
    }
  }

  renderTurnstile() {
    const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;
    if (!siteKey || !this.turnstileRef.current) return;

    const turnstile = (window as any).turnstile;
    if (turnstile) {
      this.turnstileWidgetId = turnstile.render(this.turnstileRef.current, {
        sitekey: siteKey,
      });
    } else {
      const script = document.querySelector(
        'script[src*="challenges.cloudflare.com/turnstile"]',
      ) as HTMLScriptElement | null;
      script?.addEventListener('load', () => this.renderTurnstile(), { once: true });
    }
  }

  resetTurnstile() {
    if (this.turnstileWidgetId !== undefined) {
      (window as any).turnstile?.reset(this.turnstileWidgetId);
    }
  }

  onInputChange(value, e) {
    const { name } = e.target;
    this.setState(
      produce((draft) => {
        draft.values[name] = value;
        draft.dirty[name] = true;
      }),
    );
  }

  onInputBlur(e) {
    const { name } = e.target;
    this.setState(
      produce((draft) => {
        if (draft.dirty[name]) {
          draft.errors[name] = validate(name, draft.values[name]);
        }
      }),
    );
  }

  onFormSubmit(e) {
    e.preventDefault();

    const { dirty, errors, values } = this.state;

    const dirtyRef = { ...dirty };
    const dirtyKeys = Object.keys(dirty);

    dirtyKeys.forEach((key) => {
      dirtyRef[key] = true;
    });

    const errorsRef = { ...errors };
    const errorsKeys = Object.keys(errors);

    let isError = false;

    errorsKeys.forEach((key) => {
      const error = validate(key, values[key]);
      errorsRef[key] = error;
      isError = isError || !!error;
    });

    this.setState({ errors: errorsRef, dirty: dirtyRef });

    if (isError) {
      return;
    }

    const captchaToken = this.turnstileWidgetId !== undefined
      ? ((window as any).turnstile?.getResponse(this.turnstileWidgetId) || '')
      : '';
    const { onSubmit } = this.props;
    onSubmit(values.email, captchaToken);
  }

  render() {
    const { values, errors } = this.state;
    const { isLoading, buttonText } = this.props;

    return (
      <form className="auth-form" onSubmit={this.onFormSubmit}>
        <Input
          name="email"
          label="Email"
          placeholder="Enter your email address"
          value={values.email}
          variant={errors.email && Input.Variant.Error}
          caption={errors.email}
          onChange={this.onInputChange}
          onBlur={this.onInputBlur}
          autoFocus
        />

        <div ref={this.turnstileRef} />

        <ButtonContainer>
          <Button
            variant={Button.Variant.Primary}
            type={Button.Type.Submit}
            isLoading={isLoading}
            disabled={!values.email || isLoading}
            className="auth-action-btn"
          >
            {buttonText}
          </Button>
        </ButtonContainer>
      </form>
    );
  }
}

export default ResetPasswordFormComponent;
